export const getPermissionsCurrentCompany = (state) => state.permissions.current.company
